import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Disk Usage ")

export function render(_ctx, _cache) {
  const _component_Button = _resolveComponent("Button")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, null, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_Button, {
          disabled: _ctx.loading,
          icon: "pi pi-refresh",
          class: "p-button-rounded p-button-outlined",
          onClick: _ctx.refresh
        }, null, 8, ["disabled", "onClick"])
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_component_ProgressBar, {
        value: _ctx.usedPercent,
        mode: _ctx.mode,
        showValue: false
      }, null, 8, ["value", "mode"])
    ]),
    footer: _withCtx(() => [
      _createTextVNode(" Used: " + _toDisplayString(_ctx.usedPercent) + "% Size: " + _toDisplayString(_ctx.size) + " Used: " + _toDisplayString(_ctx.used) + " Available: " + _toDisplayString(_ctx.available), 1)
    ]),
    _: 1
  }))
}